import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 px-4 sm:px-6 bg-ivory" data-id="element-83">
      <div className="max-w-3xl mx-auto bg-cream border-2 border-gold/40 p-6 sm:p-10 rounded-2xl text-center shadow-lg" data-id="element-84">
        <p className="text-sm font-body font-bold text-sage uppercase tracking-widest mb-4" data-id="element-85">
          Il Tuo Investimento è 100% Protetto
        </p>
        <div className="w-20 h-20 mx-auto bg-sage/10 rounded-full flex items-center justify-center mb-4 border border-sage/20" data-id="element-86">
          <ShieldCheck className="w-10 h-10 text-sage" data-id="element-87" />
        </div>
        <h3 className="text-2xl sm:text-3xl font-heading font-bold text-petrol mb-2 uppercase leading-tight" data-id="element-88">
          🛡️ Garanzia Totale di 7 Giorni
        </h3>
        <p className="text-base sm:text-lg font-subheading font-bold text-petrol mb-4 uppercase tracking-wide" data-id="element-89">
          Il tuo denaro è 100% al sicuro.
        </p>
        <div className="text-sm sm:text-base text-graphite leading-relaxed max-w-2xl mx-auto" data-id="element-90">
          <p className="mb-3" data-id="element-91">
            Hai 7 giorni interi per esplorare tutto il sistema, rivedere le
            lezioni, implementare la programmazione e valutare i risultati con i
            tuoi partecipanti.
          </p>
          <p className="mb-3" data-id="element-92">
            Se non sei completamente soddisfatto, ti rimborseremo il 100% del
            tuo denaro.
          </p>
          <p className="font-bold text-petrol" data-id="element-93">Zero rischio per te.</p>
        </div>
      </div>
    </section>;
}